import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';

var cachedInstructionsHtml = null;

export var TransformChainHelpDialog = {

	show() {
		var openWithHtml = function (html) {
			var helpWin = ElementUtil.create({
				tag: 'dl-window',
				headertext: '',
				modal: false,
				width: '520px',
				height: '75%',
				left: Math.max(20, (window.innerWidth - 540) / 2) + 'px',
				top: '80px',
				listeners: {
					ready: function () {
						helpWin.show();

						var header = helpWin.mainPanel ? helpWin.mainPanel.querySelector('.header') : null;
						if (header) {
							var titleRow = ElementUtil.create({
								tag: 'span',
								style: 'display: inline-flex; align-items: center; gap: 8px; vertical-align: middle;',
								children: [
									{
										tag: 'vaadin-icon',
										icon: 'vaadin:question-circle'
									},
									{
										tag: 'span',
										text: 'Transform chain'
									}
								]
							});
							header.insertBefore(titleRow, header.firstChild);
						}

						var panel = helpWin.getContentPanel();
						panel.style.padding = '12px';
						panel.style.overflow = 'auto';
						panel.innerHTML = html || '<p>Instructions unavailable.</p>';
					}
				}
			});
		};

		if (cachedInstructionsHtml) {
			openWithHtml(cachedInstructionsHtml);
			return;
		}

		Service.getApplicationService().getTransformChainInstructions().then(function (data) {
			cachedInstructionsHtml = data && data.html ? data.html : '';
			openWithHtml(cachedInstructionsHtml);
		}).catch(function () {
			openWithHtml('<p>Failed to load transform chain instructions.</p>');
		});
	}
};
